module.exports = __webpack_public_path__ + "img/Spain.70c13cd0.svg";